module.exports = __webpack_public_path__ + "static/media/simplechat.6a36c1d1.png";